import auth from '../utils/auth'
import rest from '../utils/rest'
const serverUrl = process.env.VUE_APP_ROOT_API_SERVER_URL;

const tokenRequest = {
  scopes: ['api://6368fbe9-214c-4939-9499-7b8d96653f21/User.ReadWrite'],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async addAccount(account) {
    try {
      const url = `${serverUrl}/Account/Create`;
      const payload = JSON.stringify(account);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to add Account (${e.message})`)
    }
  },
  async addEggGroup(eggGroup) {
    try {
      var uploadGroup = window.structuredClone(eggGroup);
      uploadGroup.createDateTime = eggGroup.date;
      uploadGroup.samples = eggGroup.samples;

      let url = `${serverUrl}/Egg/Create`;

      const payload = JSON.stringify(uploadGroup);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
      return new Date();
    }
    catch(e) {
      throw new Error(`Unable to Create egg data for ${eggGroup.groupName} from server (${e.message})`)
    }
  },
  async addVisionGroup(visionGroup) {
    try{
      var uploadGroup = window.structuredClone(visionGroup);
      
      let url = `${serverUrl}/Vision/Create`;

      const payload = JSON.stringify(uploadGroup);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
      return new Date();
    }
    catch(e) {
      throw new Error(`Unable to create vision data for ${visionGroup.groupName} from server (${e.message})`);
    }
  },
  async uploadFiles(files) {
    try{
      let url = `${serverUrl}/Vision/UploadImages`;

      const payload = JSON.stringify(files);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
      return true;
    }
    catch(e) {
      throw new Error(`Unable to upload files to storage account. Error: (${e.message})`);
    }
  },
  async addFarm(farm) {
    try {
      const url = `${serverUrl}/Farm/Create`;
      const payload = JSON.stringify(farm);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Create Farm (${e.message})`)
    }
  },
  async addFarmLine(line) {
    try {
      const url = `${serverUrl}/Line/Create`;
      const payload = JSON.stringify(line);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Create Farm Line (${e.message})`)
    }
  },
  async addFarmOperator(operator) {
    try {
      const url = `${serverUrl}/Operator/Create?`;
      const payload = JSON.stringify(operator);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Create Farm Operator (${e.message})`)
    }
  },
  async deleteAccount(userName) {
    try {
      const url = `${serverUrl}/Account/Delete?userPrincipalName=${userName}`;
      const options = await auth.getOptions(tokenRequest, 'DELETE');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Delete Account (${e.message})`)
    }
  },
  async deleteFarm(farmCode) {
    try {
      const url = `${serverUrl}/Farm/Delete?farmCode=${farmCode}`;
      const options = await auth.getOptions(tokenRequest, 'DELETE');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Delete Farm (${e.message})`)
    }
  },
  async deleteFarmLine(farmCode, lineCode) {
    try {
      const url = `${serverUrl}/Line/Delete?farmCode=${farmCode}&lineCode=${lineCode.replace('L','')}`;
      const options = await auth.getOptions(tokenRequest, 'DELETE');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Delete Farm Line (${e.message})`)
    }
  },
  async deleteFarmOperator(operatorId) {
    try {
      const url = `${serverUrl}/Operator/Delete?operatorId=${operatorId}`;
      const options = await auth.getOptions(tokenRequest, 'DELETE');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Delete Farm Operator (${e.message})`)
    }
  },
  async getEggGrades() {
    try {
      const url = `${serverUrl}/Egg/EggGrades`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Egg Grade Qualifiers from server (${e.message})`)
    }
  },
  async getEggDaily(farm, line, mg) {
    try{
      const url = `${serverUrl}/Egg/Daily?farmCode=${farm}&lineCode=${line}&miniGenerationNum=${mg}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Egg Daily Report from server (${e.message})`)
    }
  },
  async getEggGroups(farm, clientUid, startDate, endDate) {
    try{
      let url = `${serverUrl}/Egg/EggGroups?farmCode=${farm}`;
      if (clientUid != null) url += `&clientUid=${clientUid}`;
      if (startDate != null) url += `&startDate=${startDate}`;
      if (endDate != null) url += `&endDate=${endDate}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      let results = rest.call(url, options);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to retrieve Egg Groups from server (${e.message})`)
    }
  },
  async deleteEggGroup(clientUid) {
    try {
      const url = `${serverUrl}/Egg/Delete?clientUid=${clientUid}`;
      const options = await auth.getOptions(tokenRequest, 'DELETE');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Delete Egg Group: (${e.message})`)
    }
  },
  async getEggSummary(farm, line, mg) {
    try{
      const url = `${serverUrl}/Egg/Summary?farmCode=${farm}&lineCode=${line}&miniGenerationNum=${mg}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Egg Summary Report from server (${e.message})`)
    }
  },
  async getFarms() {
    try {
      const url = `${serverUrl}/Farm/Read?enabledOnly=false`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm List from server (${e.message})`)
    }
  },
  async getFarmBadges(farmCode) {
    try {
      const url = `${serverUrl}/Badge?farmCode=${farmCode}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm Badge List from server (${e.message})`)
    }
  },
  async getReferenceBadges(farmCode) {
    try {
      const url = `${serverUrl}/Badge/GetFarmReferenceBadgeList?farmCode=${farmCode}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Reference Badges from server (${e.message})`)
    }
  },
  async getFarmHouses(farmCode) {
    try {
      const url = `${serverUrl}/House/Read?farmCode=${farmCode}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm House List from server (${e.message})`)
    }
  },
  async getFarmLines(isEnabledOnly, farmCode) {
    try {
      let enabledOnly = isEnabledOnly === undefined ? true: false;
      const url = `${serverUrl}/Line/Read?enabledOnly=${(enabledOnly ? true: false)}&farmCode=${farmCode ? farmCode : ''}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Lines from server (${e.message})`)
    }
  },
  async getFarmOperators(farmCode, isEnabledOnly) {
    try {
      let enabledOnly = isEnabledOnly === undefined ? true: false;
      let url = `${serverUrl}/Operator/Read`;
                url += `?farmCode=${farmCode ? farmCode : ''}`;
                url += `&enabledOnly=${(enabledOnly ? true: false)}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm Operator List from server (${e.message})`)
    }
  },
  async getVisionFarmOperators(farmCode, isEnabledOnly) {
    try {
      let enabledOnly = isEnabledOnly === undefined ? true: false;
      let url = `${serverUrl}/Operator/Vision/Read`;
                url += `?farmCode=${farmCode ? farmCode : ''}`;
                url += `&enabledOnly=${(enabledOnly ? true: false)}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm Vision Operator List from server (${e.message})`)
    }
  },
  async getFarmMiniGens(farmCode, isEnabledOnly) {
    try {
      let enabledOnly = isEnabledOnly === undefined ? true: false;
      let url = `${serverUrl}/MiniGeneration/Read`;
                url += `?farmCode=${farmCode ? farmCode : ''}`;
                url += `&enabledOnly=${(enabledOnly ? true: false)}`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve Farm MiniGeneration List from server (${e.message})`)
    }
  },
  async getMiniGenList() {
    try {
      const url = `${serverUrl}/MiniGeneration/Read`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve MiniGens List from server (${e.message})`)
    }
  },
  async getUserContext() {
    try {
      const url = `${serverUrl}/Account/Read`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve User Context from server (${e.message})`)
    }
  },
  async getUserAccounts() {
    try {
      const url = `${serverUrl}/Account/ReadAll`;
      const options = await auth.getOptions(tokenRequest, 'GET');
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to retrieve User Account List from server (${e.message})`)
    }
  },
  async updateAccount(account) {
    try {
      const url = `${serverUrl}/Account/Update`;
      const payload = JSON.stringify(account);
      const options = await auth.getOptions(tokenRequest, 'PUT', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to update Account (${e.message})`)
    }
  },
  async updateEggGroup(eggGroup) {
    try {
      let url = `${serverUrl}/Egg/Update`;
      eggGroup.createDateTime = eggGroup.date;
      const payload = JSON.stringify(eggGroup);
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      await rest.call(url, options);
      return new Date();
    }
    catch(e) {
      throw new Error(`Unable to Update egg data for ${eggGroup.groupName} from server (${e.message})`)
    }
  },
  async updateFarm(farm) {
    try {
      const url = `${serverUrl}/Farm/Update`;
      const payload = JSON.stringify(farm);
      const options = await auth.getOptions(tokenRequest, 'PUT', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to update Farm (${e.message})`)
    }
  },
  async updateFarmOperator(operator) {
    try {
      const url = `${serverUrl}/Operator/Update`;
      const payload = JSON.stringify(operator);
      const options = await auth.getOptions(tokenRequest, 'PUT', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to update Farm Operator (${e.message})`)
    }
  },
  async updateFarmLine(line) {
    try {
      const url = `${serverUrl}/Line/Update`;
      const payload = JSON.stringify(line);
      const options = await auth.getOptions(tokenRequest, 'PUT', payload, true);
      await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to update Farm Line (${e.message})`)
    }
  },
  async validateWingbands(farm, house, line, mg, wingbands) {
    try {
      let url = `${serverUrl}/Chicken/ValidateWingbands?farm=${farm}`;
      url += house ? `&house=${house}` : '';
      url += line ? `&line=${line}` : '';
      url += mg ? `&mg=${mg}` : '';

      const payload = JSON.stringify(wingbands)
      const options = await auth.getOptions(tokenRequest, 'POST', payload, true);
      return await rest.call(url, options);
    }
    catch(e) {
      throw new Error(`Unable to Validate Wingbands (${e.message})`)
    }
  },
  
}